export enum DashboardTrend {
  Positive = 'positive',
  Negative = 'negative',
  Neutral = 'neutral',
}

export function dashboardTrendTone(value: number) {
  if (value > 0) {
    return { trend: DashboardTrend.Positive, className: 'text-success' } as const;
  }
  if (value < 0) {
    return { trend: DashboardTrend.Negative, className: 'text-destructive' } as const;
  }
  return { trend: DashboardTrend.Neutral, className: 'text-muted-foreground' } as const;
}

export function dashboardPercentChange(current: number | undefined, previous: number | undefined) {
  if (current === undefined || previous === undefined) return null;
  if (current === previous) return 0;
  if (previous === 0) return null;
  return ((current - previous) / Math.abs(previous)) * 100;
}
